export default __webpack_public_path__ + "static/media/17-INT-(4-3).6e76d16f.jpg";